import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SKIP_LOADING } from '@core/containts';
import { LoadingService } from '@core/services/loading.service';
import { finalize } from 'rxjs';

let totalRequests = 0;

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  totalRequests++;
  loadingService.setIsLoadingState(true);

  return next(req).pipe(
    finalize(() => {
      totalRequests--;
      if (totalRequests === 0) {
        loadingService.setIsLoadingState(false);
      }
    })
  );
};
